import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import CommonHeader from '../../util_components/common_header';

import CustomSingleSelect from '../../util_components/custom_single_select';
import SmsReportDateRange from './SmsReportDateRange';
import { image_error_replace, get_date_filter_data_timezone_utc } from '../../../util_functions';
import {
  day_format,
  target_students,
  time_format,
  reply_sent_options,
  SALES_ADVISOR_TOOLTIP
} from '../../../constants';

import { post_api, get_api } from '../../../redux/api_funcs';
import * as actions from '../../../redux/action_creators';
import { get_api_url } from '../../../utils/urls';
import SmsWindow from './sms_window';
import './sms_report_v3.css';

const sched_sms_type_options = [
  'ALL',
  '10_MIN_REMINDER',
  '1_DAY_REMINDER',
  '1_HOUR_REMINDER',
  '30_MINUTE_REMINDER',
  '5_MINUTE_REMINDER',
  'CAMPAIGN',
  'CMS_MANUAL_MESSAGE',
  'CONFIRMATION',
  'CONFIRMATION_REQUIRED',
  'INACTIVE_USERS_AUTOMATED_SMS',
  'REFERRAL'
].map((v) => ({ value: v, label: v }));

class SmsReportV3 extends Component {
  state = {
    loading: false,
    date_filter_type: 'THIS WEEK',
    sms_data: [],
    scheduled_messages: [],
    view_tab: 'sent',
    send_sms_uuid: '',
    send_sms_name: '',
    sms_window_open: false,
    sms_window_student_uuid: '',
    message_dispatch_method: '',
    target_client: 'all',
    reply_filter: 'all',
    sched_sms_type: 'CMS_MANUAL_MESSAGE',
    start_date: null,
    end_date: null,
    is_allowed_whatsapp: false,
    is_allowed_sms: false
  };

  componentDidMount() {
    // Widen the shared shell for this page only (reverted on unmount); see sms_report_v3.css.
    const cpc = document.querySelector('.common-page-container');
    if (cpc) cpc.classList.add('srv3-fullwidth');

    this.props.set_home_variable('iana_timezone', 'Asia/Kolkata');
    this.load_url_params();
    this.load_data();
    this.load_scheduled_messages();
  }

  componentWillUnmount() {
    const cpc = document.querySelector('.common-page-container');
    if (cpc) cpc.classList.remove('srv3-fullwidth');
  }

  load_url_params = () => {
    const urlString = window.location.href;
    const url = new URL(urlString);
    const date_filter_type =
      url.searchParams.get('date_filter') ||
      localStorage.getItem('sms_report_date_filter') ||
      'THIS WEEK';
    const target_client =
      url.searchParams.get('target_client') ||
      localStorage.getItem('sms_report_target_client') ||
      'all';
    const start_date =
      url.searchParams.get('start_date') || localStorage.getItem('sms_report_start_date') || null;
    const end_date =
      url.searchParams.get('end_date') || localStorage.getItem('sms_report_end_date') || null;
    const view_tab =
      url.searchParams.get('view') || localStorage.getItem('sms_report_view') || 'sent';
    const reply_filter =
      url.searchParams.get('reply_filter') ||
      localStorage.getItem('sms_report_reply_filter') ||
      'all';
    const sched_sms_type =
      url.searchParams.get('sched_sms_type') ||
      localStorage.getItem('sms_report_sched_sms_type') ||
      'CMS_MANUAL_MESSAGE';

    this.setState({
      date_filter_type,
      target_client,
      reply_filter,
      sched_sms_type,
      start_date: start_date || null,
      end_date: end_date || null,
      view_tab: view_tab === 'scheduled' ? 'scheduled' : 'sent'
    });
  };

  update_url_and_storage = (params) => {
    const url = new URL(window.location.href);
    Object.keys(params).forEach((key) => {
      if (params[key]) {
        url.searchParams.set(key, params[key]);
        localStorage.setItem(`sms_report_${key}`, params[key]);
      } else {
        url.searchParams.delete(key);
        localStorage.removeItem(`sms_report_${key}`);
      }
    });
    window.history.pushState({}, '', url);
  };

  // Date filter as a UTC window; feeds the get_sms_data payload and the scheduled list.
  get_current_utc_window = () => {
    const { date_filter_type, start_date, end_date } = this.state;

    let safe_date_filter_type = date_filter_type || 'THIS WEEK';
    let safe_start_date = start_date;
    let safe_end_date = end_date;

    // If user selected CUSTOM but hasn't provided both dates, fallback to THIS WEEK
    if (safe_date_filter_type === 'CUSTOM' && (!safe_start_date || !safe_end_date)) {
      safe_date_filter_type = 'THIS WEEK';
      safe_start_date = null;
      safe_end_date = null;
    }

    const date_data = get_date_filter_data_timezone_utc(
      safe_date_filter_type,
      safe_start_date,
      safe_end_date,
      this.props.iana_timezone
    );

    // Validate helper output and fallback to UTC today range if invalid
    const date_time_format = 'YYYY-MM-DD HH:mm:ss';
    let { utc_start_date, utc_end_date } = date_data;
    if (!moment.utc(utc_start_date, date_time_format, true).isValid()) {
      utc_start_date = moment().utc().startOf('day').format(date_time_format);
    }
    if (!moment.utc(utc_end_date, date_time_format, true).isValid()) {
      utc_end_date = moment().utc().endOf('day').format(date_time_format);
    }

    return { utc_start_date, utc_end_date };
  };

  load_data = () => {
    this.setState({ loading: true }, () => {
      const url = get_api_url('get_sms_data');
      const { utc_start_date, utc_end_date } = this.get_current_utc_window();

      const payload = {
        start_date: utc_start_date,
        end_date: utc_end_date
      };
      post_api(url, payload, true)
        .then((res) => {
          this.setState({ sms_data: [...res.data.sms_data], loading: false });
        })
        .catch((e) => {
          let err_message;
          try {
            err_message = e.response.data.message;
          } catch (err) {
            err_message = 'Some error occured. Please contact dev team.';
          }
          this.setState({ loading: false });
          this.props.set_notification_variable(true, 'error', err_message);
        });
    });
  };

  // Pending messages queued in cron_sms_schedule, filtered by the shared
  // date window and the selected sms_type (default: manual CMS messages).
  load_scheduled_messages = () => {
    const { utc_start_date, utc_end_date } = this.get_current_utc_window();
    const qs =
      `?start_date=${encodeURIComponent(utc_start_date)}` +
      `&end_date=${encodeURIComponent(utc_end_date)}` +
      `&sms_type=${encodeURIComponent(this.state.sched_sms_type || 'CMS_MANUAL_MESSAGE')}`;
    const url = get_api_url(`/v2/notifications/scheduled_messages${qs}`, false, true);
    get_api(url, true)
      .then((res) => {
        const items = res?.data?.data?.scheduled_messages || [];
        this.setState({ scheduled_messages: items });
      })
      .catch((e) => {
        console.log('sms_report_v3->load_scheduled_messages->', e);
      });
  };

  apply_date_range = ({ type, start_date, end_date }) => {
    this.setState({ date_filter_type: type, start_date, end_date }, () => {
      this.update_url_and_storage({
        date_filter: type,
        start_date: start_date || null,
        end_date: end_date || null
      });
      this.load_data();
      this.load_scheduled_messages();
    });
  };

  change_target_client = (e) => {
    const target_client = e.target.value;
    this.setState({ target_client }, () => {
      this.update_url_and_storage({ target_client });
    });
  };

  change_reply_filter = (e) => {
    const reply_filter = e.target.value;
    this.setState({ reply_filter }, () => {
      this.update_url_and_storage({ reply_filter });
    });
  };

  change_sched_sms_type = (e) => {
    const sched_sms_type = e.target.value;
    this.setState({ sched_sms_type }, () => {
      this.update_url_and_storage({ sched_sms_type });
      this.load_scheduled_messages();
    });
  };

  open_sms_window = (sms) => {
    this.setState({
      sms_window_open: true,
      sms_window_student_uuid: sms.student_uuid,
      send_sms_name: sms.student_name,
      send_sms_uuid: sms.uuid,
      message_dispatch_method: sms.message_dispatch_method,
      is_allowed_whatsapp: sms.is_allowed_whatsapp,
      is_allowed_sms: sms.is_allowed_sms
    });
  };

  close_sms_window = () => {
    this.setState({
      sms_window_open: false,
      sms_window_student_uuid: '',
      send_sms_name: '',
      send_sms_uuid: ''
    });
    // A send from the window may have queued a scheduled message.
    this.load_scheduled_messages();
  };

  on_reply_sent = () => {
    const { sms_data, send_sms_uuid } = this.state;
    const new_sms_data = [...sms_data];
    const sms = new_sms_data.find((s) => s.uuid === send_sms_uuid);
    if (sms) {
      sms.reply_sent = 1;
      this.setState({ sms_data: new_sms_data });
    }
  };

  render_date_filter = () => {
    const { date_filter_type, start_date, end_date } = this.state;
    return (
      <div className="srv3-filters srv3-filters--start">
        <SmsReportDateRange
          mode={this.state.view_tab === 'scheduled' ? 'future' : 'past'}
          date_filter_type={date_filter_type}
          start_date={start_date}
          end_date={end_date}
          on_apply={this.apply_date_range}
        />
      </div>
    );
  };

  render_segmented = (label, options, value, on_select) => (
    <div className="srv3-seg-field">
      <div className="srv3-seg-label">{label}</div>
      <div
        className="srv3-seg"
        role="group"
        aria-label={label}
        style={{ '--segment-count': options.length }}
      >
        {options.map((opt) => (
          <button
            key={opt.value}
            type="button"
            className={`srv3-seg-btn ${value === opt.value ? 'srv3-seg-btn-selected' : ''}`}
            onClick={() => on_select(opt.value)}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );

  render_filters = () => {
    const { target_client, reply_filter } = this.state;

    return (
      <div className="srv3-filters srv3-filters--start">
        {this.render_segmented('Target Clients', target_students, target_client, (v) =>
          this.change_target_client({ target: { value: v } })
        )}
        {this.render_segmented('Reply Sent', reply_sent_options, reply_filter, (v) =>
          this.change_reply_filter({ target: { value: v } })
        )}
      </div>
    );
  };

  render_sms_row = (sms) => {
    const tz = this.props.iana_timezone;
    const student_url = `/studentprofile?id=${sms.student_uuid}`;
    const sent_d = moment(sms.created_date).tz(tz).format(day_format);
    const sent_t = moment(sms.created_date).tz(tz).format(time_format);
    const replied = sms.reply_sent == 1;
    const can_msg = sms.message_dispatch_method !== 'none';
    const is_wa = sms.message_dispatch_method === 'whatsapp';

    const rep_badge = replied ? (
      <span className="srv3-rep-yes">Replied</span>
    ) : (
      <span className="srv3-rep-no">Not replied</span>
    );
    // PROD-8934: churn/member tag under the name. NON_MEMBER shows nothing.
    const mtag_style = {
      display: 'inline-block',
      marginTop: '2px',
      padding: '1px 6px',
      borderRadius: '4px',
      fontSize: '11px',
      fontWeight: 600,
      lineHeight: 1.5
    };
    let membership_tag = null;
    if (sms.membership_status === 'MEMBER') {
      membership_tag = (
        <span
          style={{
            ...mtag_style,
            background: 'var(--state-success-bg)',
            color: 'var(--state-success-text)'
          }}
        >
          Active Member
        </span>
      );
    } else if (sms.membership_status === 'CHURN') {
      membership_tag = (
        <span
          style={{
            ...mtag_style,
            background: 'var(--state-warning-bg)',
            color: 'var(--state-warning-text)'
          }}
        >
          Churn User
        </span>
      );
    }
    const action = can_msg ? (
      <button
        className={`srv3-btn ${is_wa ? 'srv3-btn-wa' : 'srv3-btn-sms'}`}
        onClick={() => this.open_sms_window(sms)}
      >
        {is_wa ? 'Whatsapp' : 'SMS'}
      </button>
    ) : null;
    const advisor_el = (
      <span className="srv3-conc" title={SALES_ADVISOR_TOOLTIP}>
        <span className="srv3-trunc">{sms.sales_advisor_name}</span>
      </span>
    );

    return (
      <div className="srv3-rec" key={sms.uuid}>
        {/* table row (container >= 780px) */}
        <div className="srv3-trow">
          <div className="srv3-name-cell">
            <img className="srv3-av" src={sms.student_photo} onError={image_error_replace} alt="" />
            <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
              <a
                className="srv3-name srv3-trunc"
                href={student_url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {sms.student_name}
              </a>
              {membership_tag ? <div>{membership_tag}</div> : null}
            </div>
          </div>
          <div className="srv3-body srv3-trunc" title={sms.sms_body}>
            {sms.sms_body}
          </div>
          <div className="srv3-sent srv3-mono" style={{ fontSize: '12px', lineHeight: 1.5 }}>
            <div className="d">{sent_d}</div>
            <div className="t">{sent_t}</div>
          </div>
          <div>{rep_badge}</div>
          {advisor_el}
          <div className="srv3-act">{action}</div>
        </div>

        {/* boxed card (container < 780px) */}
        <div className="srv3-card">
          <div className="srv3-card-hd">
            <img className="srv3-av" src={sms.student_photo} onError={image_error_replace} alt="" />
            <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
              <a className="srv3-name" href={student_url} target="_blank" rel="noopener noreferrer">
                {sms.student_name}
              </a>
              {membership_tag ? <div>{membership_tag}</div> : null}
            </div>
            {rep_badge}
          </div>
          <div className="srv3-msg">{sms.sms_body}</div>
          <div className="srv3-meta">
            <span>
              <span className="k">Sent</span> {sent_d}, {sent_t}
            </span>
            <span className="srv3-meta-conc">
              <span className="k">Sales Advisor</span> {advisor_el}
            </span>
          </div>
          {action ? <div className="srv3-card-act">{action}</div> : null}
        </div>
      </div>
    );
  };

  cancel_scheduled_message = (item) => {
    const ok = window.confirm(
      `Cancel the scheduled message to ${item.student_name}? It will not be sent.`
    );
    if (!ok) {
      return;
    }
    const url = get_api_url('/v2/notifications/scheduled_messages/cancel', false, true);
    post_api(url, { uuid: item.uuid }, true)
      .then(() => {
        this.setState((prev) => ({
          scheduled_messages: prev.scheduled_messages.filter((m) => m.uuid !== item.uuid)
        }));
        this.props.set_notification_variable(true, 'success', 'Scheduled message cancelled.');
      })
      .catch((e) => {
        const err_message = e?.response?.data?.reason || 'Could not cancel the scheduled message.';
        this.props.set_notification_variable(true, 'error', err_message);
      });
  };

  render_scheduled_row = (item) => {
    const tz = this.props.iana_timezone;
    const student_url = `/studentprofile?id=${item.student_uuid}`;
    const at_report = moment.utc(item.scheduled_at).tz(tz);
    const student_tz = item.student_iana_timezone;
    const is_wa = item.message_dispatch_method === 'whatsapp';

    return (
      <div className="srv3-sched-row" key={item.uuid}>
        <div className="srv3-name-cell">
          <img className="srv3-av" src={item.student_photo} onError={image_error_replace} alt="" />
          <a
            className="srv3-name srv3-trunc"
            href={student_url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {item.student_name}
          </a>
        </div>
        <div className="srv3-body srv3-trunc" title={item.content}>
          {item.content}
        </div>
        <div className="srv3-mono" style={{ fontSize: '12px', lineHeight: 1.5 }}>
          <div>
            {at_report.format(day_format)}, {at_report.format(time_format)}
          </div>
          {student_tz ? (
            <div style={{ color: 'var(--text-muted)' }}>
              {moment.utc(item.scheduled_at).tz(student_tz).format('HH:mm')} student time
            </div>
          ) : null}
        </div>
        <div>
          <span className={`srv3-sched-badge ${is_wa ? 'wa' : 'sms'}`}>
            {is_wa ? 'Whatsapp' : 'SMS'}
          </span>
        </div>
        <div className="srv3-act">
          {item.sms_type === 'CMS_MANUAL_MESSAGE' ? (
            <button
              type="button"
              className="srv3-btn srv3-sched-cancel"
              onClick={() => this.cancel_scheduled_message(item)}
            >
              Cancel
            </button>
          ) : null}
        </div>
      </div>
    );
  };

  render_scheduled_filters = () => (
    <div className="srv3-filters srv3-filters--start">
      <div>
        <CustomSingleSelect
          label="Sms Type"
          options={sched_sms_type_options}
          onChange={this.change_sched_sms_type}
          value={this.state.sched_sms_type}
          style={{ width: '260px' }}
        />
      </div>
    </div>
  );

  render_scheduled = () => {
    const { scheduled_messages } = this.state;

    return (
      <>
        {this.render_scheduled_filters()}
        {!scheduled_messages.length ? (
          <div className="srv3-sched-empty">
            No scheduled messages for this Sms Type in the selected date range. Scheduled sends are
            usually in the future, so pick a range that includes upcoming dates.
          </div>
        ) : (
          <div className="srv3-list">
            <div className="srv3-sched-head">
              <div>Student</div>
              <div>Body</div>
              <div>Sending at</div>
              <div>Medium</div>
              <div className="rh">Action</div>
            </div>
            {scheduled_messages.map(this.render_scheduled_row)}
          </div>
        )}
      </>
    );
  };

  change_view_tab = (view_tab) => {
    this.setState({ view_tab }, () => {
      this.update_url_and_storage({ view: view_tab === 'scheduled' ? 'scheduled' : null });
      if (view_tab === 'scheduled') {
        this.load_scheduled_messages();
      }
    });
  };

  render_tabs = () => {
    const { view_tab, scheduled_messages } = this.state;
    return (
      <div className="srv3-tabs">
        <button
          type="button"
          className={`srv3-tab ${view_tab !== 'scheduled' ? 'active' : ''}`}
          onClick={() => this.change_view_tab('sent')}
        >
          Sent
        </button>
        <button
          type="button"
          className={`srv3-tab ${view_tab === 'scheduled' ? 'active' : ''}`}
          onClick={() => this.change_view_tab('scheduled')}
        >
          Scheduled{scheduled_messages.length ? ` (${scheduled_messages.length})` : ''}
        </button>
      </div>
    );
  };

  render_data = () => {
    const { sms_data, target_client, reply_filter } = this.state;
    let filter_sms = [...sms_data];

    // PROD-8934: filter on the 3-way membership_status. Non-members now means
    // "never had a membership" — churned users are their own category.
    if (target_client === 'members') {
      filter_sms = filter_sms.filter((s) => s.membership_status === 'MEMBER');
    } else if (target_client === 'churn') {
      filter_sms = filter_sms.filter((s) => s.membership_status === 'CHURN');
    } else if (target_client === 'non-members') {
      filter_sms = filter_sms.filter((s) => s.membership_status === 'NON_MEMBER');
    }

    if (reply_filter === 'replied') {
      filter_sms = filter_sms.filter((s) => s.reply_sent == 1);
    } else if (reply_filter === 'not-replied') {
      filter_sms = filter_sms.filter((s) => s.reply_sent != 1);
    }

    return (
      <div className="srv3-list">
        <div className="srv3-thead">
          <div>Student</div>
          <div>Body</div>
          <div>Sent</div>
          <div>Reply Sent</div>
          <div title={SALES_ADVISOR_TOOLTIP}>Sales Advisor</div>
          <div className="rh">Action</div>
        </div>
        {filter_sms.map(this.render_sms_row)}
      </div>
    );
  };

  render() {
    const {
      loading,
      sms_window_open,
      sms_window_student_uuid,
      send_sms_name,
      send_sms_uuid,
      message_dispatch_method,
      is_allowed_whatsapp,
      is_allowed_sms
    } = this.state;

    return (
      <CommonHeader loading={loading} title="SMS & WhatsApp Report" class_name="sms-report-page">
        <div style={{ minHeight: '400px' }} className="sms-report-content">
          {this.render_date_filter()}
          {this.render_tabs()}
          {this.state.view_tab === 'scheduled' ? (
            this.render_scheduled()
          ) : (
            <>
              {this.render_filters()}
              {this.render_data()}
            </>
          )}
        </div>
        {sms_window_open ? (
          <SmsWindow
            student_uuid={sms_window_student_uuid}
            student_name={send_sms_name}
            close_fn={this.close_sms_window}
            send_success_notification={this.on_reply_sent}
            original_message_uuid={send_sms_uuid}
            message_dispatch_method={message_dispatch_method}
            is_allowed_whatsapp={is_allowed_whatsapp}
            is_allowed_sms={is_allowed_sms}
          />
        ) : null}
      </CommonHeader>
    );
  }
}

const mapStateToProps = (state) => ({
  iana_timezone: state.home.iana_timezone
});

const mapDispatchToProps = (dispatch) => ({
  set_notification_variable: (show, type, mes) => {
    dispatch(actions.set_notification_variable(show, type, mes));
  },
  set_home_variable: (key, payload) => dispatch(actions.set_home_variable(key, payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(SmsReportV3);
